import { mergeToNewObject } from '../../../util/object.helpers'
import {
  BILLING_ACTION,
  MAIN_PROFILE_ACTION,
  TOKEN_ACTIONS
} from '../../../constants/actions'
import { selectSubscribedPackage } from '../../../util/billing.helpers'

export const billingProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case BILLING_ACTION.ON_CHANGE_STATE:
      return mergeToNewObject(state, { [payload.property]: payload.value })

    case BILLING_ACTION.ON_GENERATE_CHECKOUT_SESSION:
      return mergeToNewObject(state, {
        checkoutSessionUrl: '',
        isBillingRedirection: true
      })

    case BILLING_ACTION.ON_GENERATE_CHECKOUT_SESSION_FAILED:
      return mergeToNewObject(state, {
        checkoutSessionUrl: '',
        isBillingRedirection: false
      })

    case BILLING_ACTION.ON_GENERATE_CHECKOUT_SESSION_SUCCESS:
      return mergeToNewObject(state, {
        checkoutSessionUrl: payload.url,
        isBillingRedirection: false
      })

    case MAIN_PROFILE_ACTION.ON_LOAD_MAIN_DATA_SUCCESS:
      const { packageSubscriptions, currentToken } = payload
      const subscribedPackage = selectSubscribedPackage(
        packageSubscriptions,
        currentToken
      )
      const isYearly =
        subscribedPackage?.details?.isYearly !== undefined
          ? subscribedPackage?.details?.isYearly
          : state.isYearly
      return mergeToNewObject(state, {
        subscribedPackage,
        isYearly
      })

    case BILLING_ACTION.ON_GENERATE_VIEW_BILLING_SESSION:
    case BILLING_ACTION.ON_GENERATE_VIEW_BILLING_SESSION_FAILED:
      return mergeToNewObject(state, {
        viewBillingSessionUrl: '',
        isBillingRedirection: true
      })

    case BILLING_ACTION.ON_GENERATE_VIEW_BILLING_SESSION_SUCCESS:
      return mergeToNewObject(state, {
        viewBillingSessionUrl: payload.url,
        isBillingRedirection: true
      })

    case BILLING_ACTION.ON_GET_EXCHANGE_PERFORMANCE_SUCCESS:
      const { exchangeInTxValue, exchangeOutTxValue } = payload
      return mergeToNewObject(state, {
        exchangePerformance: {
          exchangeInTxValue,
          exchangeOutTxValue
        }
      })

    case BILLING_ACTION.ON_UPDATE_PACKAGE_SUBSCRIPTION_SUCCESS:
      return mergeToNewObject(state, updateSubscriptionState(payload, state))

    case TOKEN_ACTIONS.ON_CREATE_TOKEN_SUCCESS:
      return mergeToNewObject(state, { isYearly: true })

    default:
      return state
  }
}

const INITIAL_STATE = {
  isYearly: true,
  isBillingRedirection: false,
  subscribedPackage: null,
  exchangePerformance: {
    exchangeInTxValue: 0,
    exchangeOutTxValue: 0
  },
  checkoutSessionUrl: '',
  viewBillingSessionUrl: ''
}

export const BILLING_PROFILE_DISPATCH = {
  IS_YEARLY: 'isYearly',
  CHECKOUT_SESSION_URL: 'checkoutSessionUrl',
  VIEW_BILLING_SESSION_URL: 'viewBillingSessionUrl'
}

const updateSubscriptionState = (subscription, state) => {
  return {
    subscribedPackage: { ...state.subscribedPackage, ...subscription }
  }
}
